import { render, staticRenderFns } from "./ChangePermission.vue?vue&type=template&id=19572de5&scoped=true"
import script from "./ChangePermission.vue?vue&type=script&lang=js"
export * from "./ChangePermission.vue?vue&type=script&lang=js"
import style0 from "./ChangePermission.vue?vue&type=style&index=0&id=19572de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19572de5",
  null
  
)

export default component.exports